export default __webpack_public_path__ + "static/media/21.b8676c64.jpg";